var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { attrs: { id: "app-container" } },
        [
          _c("IyNavbar"),
          _c("IyAppMain", { staticStyle: { "margin-top": "48px" } }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }